<template>
  <v-container class="pa-0" fluid>
    <v-row no-gutters class="video-area">
      <video-box v-for="subscriber in participants" :key="subscriber.id" :participant="subscriber" />

      <!-- <template v-for="n in 2">
        <v-col cols="6" :key="n">
          <video  autoplay loop controls muted>
            <source src="http://techslides.com/demos/sample-videos/small.mp4" type="video/mp4">
          </video>
        </v-col>
      </template> -->
    </v-row>
  </v-container>
</template>

<script>
  import VideoBox from './VideoBox'
  import Twilio, { createLocalVideoTrack } from 'twilio-video'
  import { mapGetters } from 'vuex'

  export default {
    components: {
      VideoBox
    },
    props: {
      conference: {
        type: String,
        required: true
      }
    },
    data () {
      return {
        openContextualArea: false,
        activedMenu: null,
        voiceActived: true,
        videoActived: true,
        loading: false,
        data: {},
        localTrack: false,
        remoteTrack: '',
        activeRoom: '',
        previewTracks: '',
        identity: '',
        participants: [1,2]
      }
    },
    computed: {
      ...mapGetters({
        userId: 'user/id',
        roomName: 'app/activeConferenceId'
      }),
    },
    mounted () {
      this.$store.dispatch('app/videoConferenceToken', this.conference).then(response => {
        const token = response.data.token
        let connectOptions = {
          name: this.roomName
          // logLevel: 'debug',
          // audio: true,
          // video: { width: 400 }
        }

        Twilio.connect(token, connectOptions).then(room => {
          this.activeRoom = room
          this.loading = false

          room.on('disconnected', room => {
            this.localTrack.stop()
            room.disconnect()
          })

          room.on('trackSubscribed', (track, participant) => {
            // this.dispatchLog(participant.identity + ' added track: ' + track.kind)
            track.identity = participant.identity

            for(const participantP of room.participants) {
              if(track.kind === 'video') {
                const p = participantP.pop()
                const tracks = Array.from(p.tracks.values())
                const trackVideo = tracks.find(item => item.kind === 'video')

                if (track.name === trackVideo.track.name) {
                  track.identity = p.identity
                  this.participants.push(track)
                }
              }
            }

            let previewContainer = document.getElementById('remoteTrack')
            this.attachTracks([track], previewContainer)
          })

          // When a Participant removes a Track, detach it from the DOM.
          room.on('trackUnsubscribed', (track, /*participant */) => {
            if (track.kind === 'video') {
              this.participants = this.participants.filter(item => item.id !== track.id)
            }
            console.log('ssss')
            this.detachTracks([track])
          })

          // When a Participant leaves the Room, detach its Tracks.
          room.on('participantDisconnected', participant => {
            console.log('saiu')
            // this.dispatchLog("Participant '" + participant.identity + "' left the room")
            this.detachParticipantTracks(participant)
          })

          if (!this.localTrack) {
            createLocalVideoTrack().then(track => {
              // let localMediaContainer = document.getElementById('localTrack')
              // localMediaContainer.appendChild(track.attach())
              // console.log('createLocalVideoTrack', room.localParticipant.identity)
              // const tracks = Array.from(room.localParticipant.tracks.values())
              // const trackP = tracks.find(item => item.kind === 'video')
              track.identity = room.localParticipant.identity
              this.participants.push(track)
              this.localTrack = track
            })
          }
        })
      }).catch(e => {
        console.log('e', e)
      })
    },
    created () {
      // window.addEventListener('beforeunload', this.destroySesion)
      window.addEventListener('beforeunload', this.leaveRoomIfJoined)
    },
    beforeDestroy () {
      // window.removeEventListener('beforeunload', this.destroySesion)
      this.destroySesion()
    },
    methods: {
      dispatchLog (message) {
        console.log(message)
      },
      // Attach the Tracks to the DOM.
      attachTracks (tracks, container) {
        tracks.forEach(track => {
          track.kind !== 'video' && container.appendChild(track.attach())
        })
      },
      // Attach the Participant's Tracks to the DOM.
      attachParticipantTracks (participant, container) {
        let tracks = Array.from(participant.tracks.values())
        this.attachTracks(tracks, container)
      },
      // Detach the Tracks from the DOM.
      detachTracks (tracks) {
        tracks.forEach(track => {
          track.detach && track.detach().forEach(detachedElement => detachedElement.remove())
          track.stop && track.stop()
        })
      },
      // Detach the Participant's Tracks from the DOM.
      detachParticipantTracks (participant) {
        let tracks = Array.from(participant.tracks.values())
        this.detachTracks(tracks)
      },
      // Leave Room.
      leaveRoomIfJoined () {
        if (this.activeRoom) {
          this.activeRoom.disconnect()
        }
      },
      toggleAudio (index) {
        let status = this.users[index].actions.audio
        this.users[index].actions.audio = !status
      },
      toggleVideo (index) {
        let status = this.users[index].actions.video
        this.users[index].actions.video = !status
      },
      close () {
        this.openContextualArea = false
      },
      menuClicked (routeName) {
        this.$router.push({ name: routeName })
        this.openContextualArea = true
      },
      destroySesion () {
        // this.$store.commit('videoconference/DESTROY_SESSION')
      },
      menuActived (routeName) {
        let videoConferenceId = this.$route.params.videoConferenceId
        let path = this.$route.path.split(videoConferenceId).slice(-1)
        if (path[0].length > 1) {
          this.openContextualArea = routeName === this.$route.name
        } else {
          this.openContextualArea = false
        }
      }
    }
  }
</script>

<style lang="sass">
  @import '../assets/style/variables'

  // .container.grid-list-xs .area-video .flex
  //   padding: 0

  .video-area
    .media-content
      position: relative
      video
        width: 100%
        object-fit: cover
        height: 170px

      .area-video-info
        display: flex
        align-items: center
        justify-content: space-between
        padding: 0 15px
        position: absolute
        bottom: 0
        left: 0
        width: 100%
        background-color: rgba(255,255,255, .7)
        height: 45px

  .area-video
    // height: calc(100vh - 50px)

    .flex
      .d-flex
        position: relative
      video
        width: 100%
        object-fit: cover
        height: auto

    .action-audio
      right: 60px

    .action-video
      right: 10px

    .area-video-info
      display: flex
      align-items: center
      justify-content: space-between
      padding: 0 15px
      position: absolute
      bottom: 0
      left: 0
      width: 100%
      background-color: rgba(255,255,255, .7)
      height: 45px

      .v-tooltip
        top: -20px

    .area-video-footer
      align-items: flex-end

      .v-icon
        // align-self: center
        padding-bottom: 35px
        padding-right: 10px

  .opened-body-contextual .area-video
    .area-video-mini
      flex-direction: column
      flex-wrap: nowrap

      .v-card
        flex-basis: 100%!important

      .area-video-footer
        // display: none!important
</style>
